import SortAscendingIcon from "../../../../../../../../../assets/svg/sort-ascending-icon";
import SortDescendingIcon from "../../../../../../../../../assets/svg/sort-descending-icon";

export const SORT_OPTIONS = [
  {
    id: "newest",
    label: "Newest First",
    subtitle: "(New comments)",
    icon: SortAscendingIcon,
  },
  {
    id: "oldest",
    label: "Oldest First",
    subtitle: "(Old comments)",
    icon: SortDescendingIcon,
  },
];
